import React, {Component} from 'react';
import qs from 'qs';
import '../styles/formlicence.css';
import { load as loadLicence, edit as editLicence, add as addLicence } from '../services/licenceService';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import {
  Box,
  Paper,
  Stack,
  Typography,
  TextField,
  FormControlLabel,
  Switch,
  Button,
  Snackbar,
  Alert,
  CircularProgress
} from '@mui/material';

class Formlicence extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: new Date(),
      endDate: null,
      max_views: '',
      ai_analyses_included: '',
      active: false,
      submitting: false,
      snackbar: { open: false, severity: 'success', message: '' }
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.queriesformlicence = this.queriesformlicence.bind(this);
    this.handleChangeDate = this.handleChangeDate.bind(this);
    this.handleChangeDateEnd = this.handleChangeDateEnd.bind(this);
    this.closeSnackbar = this.closeSnackbar.bind(this);
  }

  async componentDidMount() {
    const parsed = qs.parse(this.props.location.search, {ignoreQueryPrefix: true});
    if (parsed.licence_id && parsed.licence_id !== 'undefined' && parsed.licence_id.length > 0) {
      const Licence = await loadLicence(parsed.website_id, parsed.licence_id);
      this.setState({
        max_views: Licence.max_views || '',
        ai_analyses_included: Licence.ai_analyses_included || '',
        active: !!Licence.active,
        startDate: Licence.date_start ? new Date(Licence.date_start) : new Date(),
        endDate: Licence.date_end ? new Date(Licence.date_end) : null
      });
    }
  }

  closeSnackbar() {
    this.setState({ snackbar: { ...this.state.snackbar, open: false } });
  }

  async queriesformlicence(event) {
    event.preventDefault();
    const parsed = qs.parse(this.props.location.search, {ignoreQueryPrefix: true});

    const payload = {
      max_views: this.state.max_views,
      ai_analyses_included: this.state.ai_analyses_included,
      date_start: this.state.startDate,
      date_end: this.state.endDate,
      active: !!this.state.active,
    };

    this.setState({ submitting: true });
    try {
      const isEdit = parsed.licence_id && parsed.licence_id !== 'undefined' && parsed.licence_id.length > 0;
      if (isEdit) {
        await editLicence(parsed.website_id, parsed.licence_id, payload);
      } else {
        await addLicence(parsed.website_id, payload);
      }
      this.setState({ snackbar: { open: true, severity: 'success', message: 'Licence sauvegardée.' } });
      setTimeout(() => {
        this.props.history.push(`/super-admin/Listlicence?website_id=${parsed.website_id}`);
      }, 600);
    } catch (e) {
      this.setState({ snackbar: { open: true, severity: 'error', message: 'Erreur lors de l’enregistrement.' } });
    } finally {
      this.setState({ submitting: false });
    }
  }

  handleChangeDate(date) {
    this.setState({startDate: date});
  }

  handleChangeDateEnd(date) {
    this.setState({endDate: date});
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({ [name]: value });
  }

  render() {
    const { submitting, snackbar } = this.state;

    return (
      <Box sx={{ p: 2 }}>
        <Paper variant="outlined" sx={{ p: 3, maxWidth: 600, mx: 'auto' }}>
          <Typography variant="h6" sx={{ mb: 2 }}>Licence System</Typography>

          <Box component="form" onSubmit={this.queriesformlicence}>
            <Stack spacing={2}>
              <Box>
                <Typography variant="subtitle2">Start-Date</Typography>
                <DatePicker
                  selected={this.state.startDate}
                  selectsStart
                  startDate={this.state.startDate}
                  endDate={this.state.endDate}
                  onChange={this.handleChangeDate}
                  dateFormat="yyyy-MM-dd"
                />
              </Box>

              <Box>
                <Typography variant="subtitle2">End-Date</Typography>
                <DatePicker
                  selected={this.state.endDate}
                  selectsEnd
                  startDate={this.state.startDate}
                  endDate={this.state.endDate}
                  onChange={this.handleChangeDateEnd}
                  minDate={this.state.startDate}
                  dateFormat="yyyy-MM-dd"
                />
              </Box>

              <FormControlLabel
                control={<Switch name="active" checked={!!this.state.active} onChange={this.handleInputChange} />}
                label="Active-Licence"
              />

              <TextField
                label="Max-views"
                name="max_views"
                type="number"
                value={this.state.max_views || ''}
                onChange={this.handleInputChange}
                fullWidth
                inputProps={{ min: 0 }}
              />

              {/* B6_01 (D46) : analyses IA INCLUSES au forfait signé, par mois (site sur mesure).
                  Facultatif : le contrôleur rejette en 400 une valeur non entière ou <= 0, et une
                  case vidée à l'édition retire la valeur ($unset, D43). Ce n'est pas un plafond :
                  le site n'est jamais coupé, au-delà les conditions du contrat s'appliquent. */}
              <TextField
                label="AI analyses included / month"
                name="ai_analyses_included"
                type="number"
                value={this.state.ai_analyses_included || ''}
                onChange={this.handleInputChange}
                fullWidth
                inputProps={{ min: 1 }}
                helperText="Included in the signed package. Empty = default value (10,000) shown to the client."
              />

              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  type="submit"
                  variant="contained"
                  disabled={submitting}
                  startIcon={submitting ? <CircularProgress size={18} /> : null}
                >
                  {submitting ? 'Saving...' : 'Save'}
                </Button>
              </Box>
            </Stack>
          </Box>
        </Paper>

        <Snackbar
          open={snackbar.open}
          autoHideDuration={3000}
          onClose={this.closeSnackbar}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
          <Alert onClose={this.closeSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Box>
    );
  }
}

export default Formlicence;